import React from 'react';
import { Chat } from '../types/chat';

interface ChatListItemProps {
  chat: Chat;
  isActive: boolean;
  onClick: () => void;
}

const ChatListItem: React.FC<ChatListItemProps> = ({ chat, isActive, onClick }) => {
  const formatDate = (timestamp: number) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString();
  };

  return (
    <div 
      className={`chat-item ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      <div className="chat-title">{chat.title}</div>
      <div className="chat-date">{formatDate(chat.updatedAt)}</div>
    </div>
  );
};

export default ChatListItem; 